'use client';

export function TypingIndicator() {
  return (
    <div className="flex justify-start">
      <div className="bg-light-purple/70 px-4 py-3 rounded-2xl rounded-bl-md">
        <div className="flex items-center gap-1">
          <span
            className="w-2 h-2 bg-off-black/40 rounded-full animate-bounce"
            style={{ animationDelay: '0ms' }}
          />
          <span
            className="w-2 h-2 bg-off-black/40 rounded-full animate-bounce"
            style={{ animationDelay: '150ms' }}
          />
          <span
            className="w-2 h-2 bg-off-black/40 rounded-full animate-bounce"
            style={{ animationDelay: '300ms' }}
          />
        </div>
      </div>
    </div>
  );
}
